import React from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import Loader from "components/Loader/Loader"
import BreadCrumb from "components/BreadCrumb/BreadCrumb"
import Pagination from "components/Pagination/Pagination"
import VideoGrid from "components/VideoGrid/VideoGrid"
import TileVideo from "components/TileVideo/TileVideo"
import GridTitle from "components/GridTitle/GridTitle"

import selectGenre from "selectors/genres"
import { selectReferencesModel } from "selectors/references"

import FormatterHelper from "helpers/formatter"
import routeHelper from "helpers/route"

import consts from "consts"
import styles from "./pageGenre.css"
import PageActions from "components/PageActions/PageActions"
import { useOnCTAClick } from "helpers/CTA"
import { LOCALE } from "consts/locale"

const generateSubTitle = (categorylabel, genreTitle) => {
  if (/^[aeiouh]/i.test(genreTitle)) {
    return `${categorylabel} d'${genreTitle.toLowerCase()} à découvrir sur Molotov`
  }

  return `${categorylabel} de ${genreTitle.toLowerCase()} à découvrir sur Molotov`
}

export default function PageGenreView({ categoryId, page, genreId, categorySlug, genreSlug }) {
  const references = useSelector(selectReferencesModel)
  const genre = useSelector(selectGenre)

  const category = references.getCategory(categoryId)

  const breadcrumb = [
    {
      route: FormatterHelper.basic(consts.routes.seoHome, { locale: LOCALE }),
      name: "Programme TV",
    },
    {
      route: FormatterHelper.basic(consts.routes.category, { locale: LOCALE, categoryId, categorySlug: category.slug_seo }),
      name: category.label,
    },
    {
      route: FormatterHelper.basic(consts.routes.genre, {
        locale: LOCALE,
        categoryId,
        categorySlug,
        genreId,
        genreSlug,
      }),
      name: genre.title,
    },
  ]

  const currentPage = routeHelper.getCurrentPage(page)

  const onCTAClick = useOnCTAClick()

  return (
    <PageActions onClick={onCTAClick}>
      <div className={styles.root}>
        <BreadCrumb steps={breadcrumb} />
        <h1 className={styles.title}>{`${genre.title} à regarder en streaming sur Molotov ${currentPage ? `- Page ${currentPage + 1}` : ""}`}</h1>
        {genre.pending ? (
          <Loader centerInParent />
        ) : (
          genre
            .getSections()
            .filter(section => section.getItemsCount() && section.slug === genreSlug)
            .map(section => (
              <div key={section.getSlug()}>
                <GridTitle>{generateSubTitle(category.label, genre.title)}</GridTitle>
                <VideoGrid>
                  {section.getItems().map((program, index) => (
                    <TileVideo
                      key={`${index}-${program.getId()}`}
                      useMicroData={false}
                      displaySubtitle={section.shouldDisplaySubtitle()}
                      tile={program}
                    />
                  ))}
                </VideoGrid>
                <Pagination
                  section={section}
                  currentPage={currentPage}
                  route={consts.routes.genrePage}
                  routeParams={{ locale: LOCALE, categoryId, categorySlug, genreId, genreSlug }}
                />
              </div>
            ))
        )}
      </div>
    </PageActions>
  )
}

PageGenreView.propTypes = {
  categoryId: PropTypes.string.isRequired,
  genreId: PropTypes.string.isRequired,
  genreSlug: PropTypes.string.isRequired,
  page: PropTypes.string,
  categorySlug: PropTypes.string,
}
